import { Spinner } from '@toggle/design-system';
import { formatFileSize } from '@toggle/helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { UploadedFile } from '~/views/alfred/research/useUserUpload/use-user-upload.types';
import { useUserUpload } from '~/views/alfred/research/useUserUpload/useUserUpload';

import * as S from './SingleFile.styles';

export const SingleFile = ({
  field_name,
  fileType,
  thumbnailUrl,
  name,
  status,
  sizeInBytes,
  errorMessage,
}: UploadedFile) => {
  const { t } = useTranslation(['chat']);

  const removeFile = useUserUpload(state => state.removeFile);

  const locales = {
    byte: t('chat:fileSizes.byte'),
    kilobyte: t('chat:fileSizes.kilobyte'),
    megabyte: t('chat:fileSizes.megabyte'),
    gigabyte: t('chat:fileSizes.gigabyte'),
    terabyte: t('chat:fileSizes.terabyte'),
  };

  return (
    <S.SingleFileRoot>
      <S.PreviewWrapper>
        <S.IconWrapper>
          <div>
            {fileType !== 'application/pdf' && status !== 'complete' && (
              <S.GreyOverlay data-testid="grey-overlay" />
            )}
            <S.StyledImage
              data-testid="file-icon"
              src={
                fileType === 'application/pdf'
                  ? '/app/static/images/icons/pdf.svg'
                  : thumbnailUrl
              }
              $status={status}
              $isPdf={fileType === 'application/pdf'}
              alt={name}
            />
          </div>
        </S.IconWrapper>
        {status === 'uploading' && (
          <S.SpinnerWrapper>
            <Spinner size="small" />
          </S.SpinnerWrapper>
        )}
        {status === 'error' && (
          <S.StyledErrorIcon
            iconName="ExclamationCircle"
            size={16}
            fillColor="var(--icon-critical)"
          />
        )}
      </S.PreviewWrapper>
      <S.FileInfoWrapper>
        <S.FileName $status={status}>{name}</S.FileName>
        <S.FileSize $status={status}>
          {formatFileSize({ sizeInBytes, decimals: 2, locales })}&nbsp;
          {status === 'error' && (
            <S.ErrorMessage data-testid="error-message">
              &#x2022;&nbsp;{errorMessage || ''}
            </S.ErrorMessage>
          )}
        </S.FileSize>
      </S.FileInfoWrapper>
      <S.StyledIcon
        iconName="Close"
        onClick={() => {
          removeFile(field_name);
        }}
        size={12}
      />
    </S.SingleFileRoot>
  );
};
